var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBulletFooterNav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "10px",
    viewBox: "0 0 18 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "bullet-footerNav") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layout/footer",
    transform: "translate(-317.000000, -35.000000)",
    fill: "#FF1616"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-23",
    transform: "translate(20.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bullet-footerNav",
    transform: "translate(297.000000, 35.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9996778,0 L17.9996,4.999 L10.9996778,10 L10.9996778,0 Z M9.99988889,3.9989 L9.99988889,5.9999 L0,5.9999 L0,3.9989 L9.99988889,3.9989 Z",
    id: "Combined-Shape-Copy"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulletFooterNav);
export default __webpack_public_path__ + "static/media/bullet-footerNav.b542660e8d5e2be89599b63ee9b6eeeb.svg";
export { ForwardRef as ReactComponent };